import React from 'react';
import { useNavigate } from 'react-router-dom';
import RasaIntentManager from '../components/RasaIntentManager';

const IntentsPage = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate('/');
    };

    const handleSave = (data) => {
        console.log('RASA data saved:', data);
        // You can add additional logic here if needed
    };

    return (
        <div className="intents-page">
            <RasaIntentManager onSave={handleSave} onClose={handleClose} />
        </div>
    );
};

export default IntentsPage;

